import { Component, OnInit, Input } from '@angular/core';
import { SetService, HttpService } from 'ngx-block-core';
import { FormControlService } from "ngx-block-core";
import { selectTextColor } from "../../../data/data";

@Component({
  selector: 'sucu06-element0010003',
  templateUrl: './sucu06-element0010003.component.html',
  styleUrls: ['./sucu06-element0010003.component.css']
})
export class Sucu06Element0010003Component implements OnInit {

  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() nzFormGroupData;
  @Input() nzLayout = 'horizontal'

  value
  @Input() sets = {
    blockCode: "sucublock33",
    blockId: "",
    layoutId: "",
    blockType: 'element',
    blockChildType: '',
    versionCode: 2,
    styles: {
      nzTitle: "标签",
      nzTextStyle: "",
      nzTextSize: "",
      nzTextAlign: "",
      nzTextColor: "",
      nzTextFormat: ""


    },
    datas: {
      nzDynamicValue: {
        nzUsed: false,
        nzDynamicSql: ""

      }

    }
  };

  setData = []

  constructor(
    public setService: SetService,
    private formControlService: FormControlService,
    private http: HttpService,

  ) { }
  ngOnInit() {

    this.baseInit();
    this.getControl();
    this.autoUpdate();
  }

  autoUpdate() {

    //v3,升级自定义表单参数
    if (this.sets.versionCode < 2) {

      this.sets.blockCode = "sucublock33";

      this.sets.versionCode = 2;
    }

  }

  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              {
                name: 'nzDefault',
                outputs: {
                  ngModelChange: (event) => {
                    this.setService.setDatas[this.blockid][0]['datas'][0]['data'][1]['show'] = event;
                  }
                }
              },
              {
                name: 'button',
                show: this.sets.datas.nzDynamicValue.nzUsed,
                inputs: { nzText: ['刷新'], nzLayout: [0, 24], nzAligns: ['center'] },
                outputs: {
                  onClick1: () => {
                    this.setService.onReLoadbBlock(this.layoutid)

                  }
                }
              },
            ]
          }


        ]
      },
      {
        tabName: '样式',
        datas: [

          {
            type: 'styles',
            data: [
              {
                name: 'select',
                inputs: { nzText: "主题:", nzKeys: ['styles', 'nzTextColor'], nzData: selectTextColor }
              },
              {
                name: 'color',
                inputs: { nzText: "自定义颜色 : ", nzKeys: ['styles', 'nzTextColor'] }
              },



            ]
          },

        ]
      },

    ]
  }
  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        console.log("sets", this.sets, this.blockid)

        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;


        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }


      }
      else {//静态
        if(typeof this.sets=="string")
        this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
      }
    }
  }

  getControl() {

    if (this.sets.datas.nzDynamicValue.nzUsed) {
      let body = {
        // 
        // "dynamicSql": 'select test001_name as value from t_test001 where test001_id=16',
        "dynamicSql": this.sets.datas.nzDynamicValue.nzDynamicSql,
        "pageSize": 0,
        "nowPage": 0,
        "paramMap": [],
        "tableSort": [],
        "searchMap": {
        }
      }
      this.http.postHttp("/system/dynamicSql", body).subscribe(
        (data: any) => {
          console.log("dynamicSql:" + JSON.stringify(data));
          this.sets.styles.nzTitle = data.data.list[0]['value'];

        }, (error: any) => {

          this.sets.styles.nzTitle = "sql错误";

        })
    }

  }


}
